
<app-type-adresse-complete-morale *ngIf="isLotAttribue()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [titulaire]="attribue?.titulaire" [errorMessagePersonneMoral]="errorMessagePersonneMoral" [required]="'required'">
</app-type-adresse-complete-morale>
<app-type-adresse-complete-morale *ngIf="!isLotAttribue()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [titulaire]="attribue?.titulaire" [errorMessagePersonneMoral]="errorMessagePersonneMoral" [required]="'required'">
</app-type-adresse-complete-morale>
<fieldset>
    <legend>
        {{ step5.getspan9 | translate }}
    </legend>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''" [label]="step5.getmontantindefini"
        [type]="'checkbox'" [rule]="'pattern_29'" [name]="getUid() + '_SepAtt_montantIndefini'"
        [isChecked]="attribue?.montantIndefini" [checkboxDestination]="'string'">
    </app-form-input>
    <div *ngIf="isMontantDefini()">
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.montant?.valeur"
            [label]="step5.getvaleur" [type]="'number'" [rule]="'digits_2|required'" [errorMessage]="{'required' : 'ctr_348'}"  [name]="getUidTypeMontant() + '_SepAtt_valeur'">
        </app-form-input>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.montant?.devise"
            [label]="step5.getdevise"
            [type]="'autocomplete'"
            [autoCompleteType]="'DEVISE'"
            [autoCompleteTypeIndex]="0"
            [rule]="'pattern_13|required'"
            [errorMessage]="{}"
            [name]="getUidTypeMontant() + '_SepAtt_devise'">
        </app-form-input>
        <app-montant-annuel [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
            [montantAnnuel]="attribue?.montantAnnuel">
        </app-montant-annuel>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.trancheConditionnelle"
            [label]="step5.gettrancheconditionnelle" [type]="'text'" [rule]="'minSize_5|maxSize_2000'"
            [name]="getUid() + '_SepAtt_trancheConditionnelle'">
        </app-form-input>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.trancheFerme"
            [label]="step5.gettrancheferme" [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUid() + '_SepAtt_trancheFerme'">
        </app-form-input>
        <app-offres [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [offres]="attribue?.offres">
        </app-offres>
    </div>
</fieldset>
<fieldset>
    <legend>
        {{ step5.getspan10 | translate }}
    </legend>
    <app-form-input [label]="" [name]="radioButtonCtrlName" [parentForm]="parentForm" [disabled]="disabled"
        [type]="'radio'" [rule]="''" [radios]="[
    {
        value: true,
        label: step5.getspan11
    },
    {
        value: false,
        label: step5.getsoustraitancenon
    }
]" [value]="attribue?.isSousTraitance">
    </app-form-input>
    <app-sous-traitance-oui *ngIf="isSousTraitance()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
        [sousTraitanceOui]="attribue?.sousTraitanceOui" [index]="index"></app-sous-traitance-oui>
</fieldset>
